import { render, staticRenderFns } from "./FormsContacts.vue?vue&type=template&id=7321dcf1&scoped=true"
import script from "./FormsContacts.vue?vue&type=script&lang=js"
export * from "./FormsContacts.vue?vue&type=script&lang=js"
import style0 from "./FormsContacts.vue?vue&type=style&index=0&id=7321dcf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321dcf1",
  null
  
)

export default component.exports